export default __webpack_public_path__ + "static/media/set-new-password-illustration.e47b4da9.svg";